// src/pages/NotFoundPage.js — Premium 404
import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{background:'#fffaf0'}}>
      <div className="absolute inset-0 deco-stripes opacity-20 pointer-events-none"/>
      <div className="text-center animate-fade-up max-w-lg">
        <div className="text-8xl mb-6 animate-bounce" style={{animationDuration:'2s',filter:'drop-shadow(0 0 20px rgba(192,21,42,0.3))'}}>🧨</div>
        <h1 className="font-black text-gray-900 mb-3"
          style={{fontFamily:'"Playfair Display",serif', fontSize:'clamp(4rem,12vw,8rem)', lineHeight:1}}>
          <span style={{ color: '#c0152a' }}>
            404
          </span>
        </h1>
        <p className="text-2xl font-black text-gray-700 mb-2">Page Went Up in Smoke!</p>
        <p className="text-gray-400 text-sm mb-10 leading-relaxed">
          The page you're looking for has exploded into thin air.<br/>
          Let's get you back to the celebration.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/"
            className="group relative bg-gradient-to-br from-red-600 to-red-800 text-white
              font-black px-8 py-4 rounded-2xl shadow-xl shadow-red-600/30
              hover:shadow-red-600/50 hover:-translate-y-1
              transition-all duration-300 overflow-hidden">
            <span className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%]
              transition-transform duration-700 bg-gradient-to-r from-transparent via-white/15 to-transparent skew-x-12"/>
            🏠 Back to Home
          </Link>
          <Link to="/products"
            className="border-2 border-gray-200 text-gray-600 hover:border-red-300 hover:text-red-600
              font-bold px-8 py-4 rounded-2xl transition-all duration-200 hover:-translate-y-0.5">
            Shop Products
          </Link>
        </div>
      </div>
    </div>
  );
}
